import axios from 'axios'

export default {
  save(data) {
    return axios.post('/worklines', data).then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },

  list(params) {
    return axios.get('/worklines', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },

  changeStatus(id, status) {
    return axios.post('/worklines/' + id + '/changeStatus', { status }).then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },

  delete(id) {
    return axios.post('/worklines/' + id + '/delete').then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
}
